import { axios } from '@/utils/axios'
import { partition } from 'lodash'
// import moment from 'moment'

export async function fetchPopupContent (params) {
  try {
    return await axios.post('/api/bff/cms/popup', { ...params, source: 'pc' })
  } catch (error) {
    return Promise.reject(error)
  }
}

// 获取图片验证码
export async function fetchImageCaptcha () {
  return axios.post('/api/oauth/captcha/normal')
}

// 校验图片验证码
export async function verifyImageCaptcha (params) {
  return axios.post('/api/oauth/captcha/normal/verify', {
    ...params
  })
}

// 获取滑块验证码
export async function fetchSliderCaptcha () {
  return axios.post('/api/oauth/captcha/slider')
}

// 校验滑块验证码
export async function verifySliderCaptcha (params) {
  return axios.post('/api/oauth/captcha/slider/verify', {
    ...params
  })
}

// 获取手机验证码
export async function getSmsCode (params) {
  return axios.get('/api/invoice/smsCode', { params: { ...params } })
}

// 获取国家列表
export async function getCountry (valueName = 'countryCode') {
  const { data } = await axios({
    url: '/psg-community-user/api/utils/countryList',
    method: 'get',
    params: {}
  })
  // 数据处理成 select 组件可以直接渲染
  let list = []
  data.forEach(item => {
    const country = {
      value: item[valueName],
      label: item.chineseName,
      id: item.id
    }

    if (country.id === 48) {
      country.isLeaf = false
      list.unshift(country)
    } else {
      list.push(country)
    }
  })
  // 把中国提到最前面
  list = partition(list, cItem => {
    return ['CN', 'HK', 'MO', 'TW'].includes(cItem.value)
  }).flat()

  return list
}

// 中文转拼音
export async function parseToPinyin (params) {
  return axios.post('/psg-community-user/api/ajax/piny', {
    ...params
  })
}

// 北美国家 & 省州字典
export async function fetchDictionaryList (params) {
  return axios.post('/psg-community-user/api/utils/dictionaryList', {
    ...params
  })
}
